import { RequestBarcodeImage } from "../request-barcode/request-barcode.component";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { RequestService } from "../../shared/services/request.service";
import { Injectable } from "@angular/core";

@Injectable()
export class RequestBarcodeResolver implements Resolve<RequestBarcodeImage> {
    constructor(private requestService: RequestService) {
    }
    resolve(route: ActivatedRouteSnapshot): Observable<RequestBarcodeImage> {
        const id: number = route.params['id'];
        return this.requestService.getBarcode(id);
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/resolvers/request-barcode.resolver.ts